import React from "react";
import { Survey, ThemeReportDataSet, SurveySegment } from "../../../../../../../amorg-common";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../../../../../designSystem/typography/Body";
import { H3 } from "../../../../../../../designSystem/typography/Heading";
import { QuestionSummaryPanel } from "./QuestionSummaryPanel";

type ThemePanelProps = {
    survey: Survey,
    siteId:string,
    themes: ThemeReportDataSet[],
    segmentFilter: SurveySegment[][],
    showComments:boolean,
}
export function ThemePanel(props: ThemePanelProps): JSX.Element {

    return (
        <>
            {props.themes.map(theme =>
                <ThemeDetails key={theme.theme.name} theme={theme} {...props} />
            )}
        </>
    );
}

type ThemeDetailsProps = {
    siteId:string,
    survey:Survey,
    theme: ThemeReportDataSet,
    segmentFilter: SurveySegment[][],
    showComments:boolean,
}
function ThemeDetails(props: ThemeDetailsProps): JSX.Element
{
    return (
        <QuestionSummaryPanel
            siteId={props.siteId}
            survey={props.survey}
            header={
                <Flex flexDirection="column">
                    <H3>{props.theme.theme.name}</H3>
                    <P>
                        Temaet indholder {props.theme.questions.length} spørgsmål
                    </P>
                </Flex>
            }
            summaryStats={props.theme.stats}
            questions={props.theme.questions}
            segmentFilter={props.segmentFilter}
            showComments={props.showComments} />
    );
}